export const STADIUM_METADATA = {
  'ARI': { name: 'Chase Field (Arizona Diamondbacks)', teamId: 109, tz: 'America/Phoenix', lat: 33.4450, lng: -112.0670 },
  'ATL': { name: 'Truist Park (Atlanta Braves)', teamId: 144, tz: 'America/New_York', lat: 33.8907, lng: -84.4677 },
  'BAL': { name: 'Oriole Park at Camden Yards (Baltimore Orioles)', teamId: 110, tz: 'America/New_York', lat: 39.2852, lng: -76.6201 },
  'BOS': { name: 'Fenway Park (Boston Red Sox)', teamId: 111, tz: 'America/New_York', lat: 42.3466, lng: -71.0988 },
  'CHC': { name: 'Wrigley Field (Chicago Cubs)', teamId: 112, tz: 'America/Chicago', lat: 41.9472, lng: -87.6564 },
  'CWS': { name: 'Guaranteed Rate Field (Chicago White Sox)', teamId: 145, tz: 'America/Chicago', lat: 41.8309, lng: -87.6351 },
  'CIN': { name: 'Great American Ball Park (Cincinnati Reds)', teamId: 113, tz: 'America/New_York', lat: 39.1072, lng: -84.5077 },
  'CLE': { name: 'Progressive Field (Cleveland Guardians)', teamId: 114, tz: 'America/New_York', lat: 41.4951, lng: -81.6871 },
  'COL': { name: 'Coors Field (Colorado Rockies)', teamId: 115, tz: 'America/Denver', lat: 39.7569, lng: -104.9653 },
  'DET': { name: 'Comerica Park (Detroit Tigers)', teamId: 116, tz: 'America/New_York', lat: 42.3390, lng: -83.0490 },
  'HOU': { name: 'Minute Maid Park (Houston Astros)', teamId: 117, tz: 'America/Chicago', lat: 29.7570, lng: -95.3560 },
  'KC': { name: 'Kauffman Stadium (Kansas City Royals)', teamId: 118, tz: 'America/Chicago', lat: 39.051605, lng: -94.480402 },
  'LAA': { name: 'Angel Stadium (Los Angeles Angels)', teamId: 108, tz: 'America/Los_Angeles', lat: 33.7996, lng: -117.8890 },
  'LAD': { name: 'Dodger Stadium (Los Angeles Dodgers)', teamId: 119, tz: 'America/Los_Angeles', lat: 34.0724, lng: -118.2469 },
  'MIA': { name: 'loanDepot park (Miami Marlins)', teamId: 146, tz: 'America/New_York', lat: 25.7781, lng: -80.2197 },
  'MIL': { name: 'American Family Field (Milwaukee Brewers)', teamId: 158, tz: 'America/Chicago', lat: 43.0284, lng: -87.9711 },
  'MIN': { name: 'Target Field (Minnesota Twins)', teamId: 142, tz: 'America/Chicago', lat: 44.9817, lng: -93.2776 },
  'NYM': { name: 'Citi Field (New York Mets)', teamId: 121, tz: 'America/New_York', lat: 40.7571, lng: -73.8458 },
  'NYY': { name: 'Yankee Stadium (New York Yankees)', teamId: 147, tz: 'America/New_York', lat: 40.8296, lng: -73.9265 },
  'OAK': { name: 'Oakland Coliseum (Oakland Athletics)', teamId: 133, tz: 'America/Los_Angeles', lat: 37.7516, lng: -122.2005 },
  'PHI': { name: 'Citizens Bank Park (Philadelphia Phillies)', teamId: 143, tz: 'America/New_York', lat: 39.9060, lng: -75.1660 },
  'PIT': { name: 'PNC Park (Pittsburgh Pirates)', teamId: 134, tz: 'America/New_York', lat: 40.4469, lng: -80.0057 },
  'SD': { name: 'Petco Park (San Diego Padres)', teamId: 135, tz: 'America/Los_Angeles', lat: 32.7077, lng: -117.1569 },
  'SEA': { name: 'T-Mobile Park (Seattle Mariners)', teamId: 136, tz: 'America/Los_Angeles', lat: 47.5914, lng: -122.3325 },
  'SF': { name: 'Oracle Park (San Francisco Giants)', teamId: 137, tz: 'America/Los_Angeles', lat: 37.7785, lng: -122.3893 },
  'STL': { name: 'Busch Stadium (St. Louis Cardinals)', teamId: 138, tz: 'America/Chicago', lat: 38.6226, lng: -90.1928 },
  'TB': { name: 'Tropicana Field (Tampa Bay Rays)', teamId: 139, tz: 'America/New_York', lat: 27.7682, lng: -82.6534 },
  'TEX': { name: 'Globe Life Field (Texas Rangers)', teamId: 140, tz: 'America/Chicago', lat: 32.7473, lng: -97.0829 },
  'TOR': { name: 'Rogers Centre (Toronto Blue Jays)', teamId: 141, tz: 'America/Toronto', lat: 43.6414, lng: -79.3894 },
  'WSH': { name: 'Nationals Park (Washington Nationals)', teamId: 120, tz: 'America/New_York', lat: 38.8732, lng: -77.0075 }
};

/**
 * Returns a human-readable stadium name derived from the model filename.
 * @param {string} fileName - Stadium filename (e.g. Stadium_KC.glb)
 * @returns {string} Human-readable stadium name
 */
export function getStadiumName(fileName) {
  if (!fileName) return 'No model loaded';
  
  // Match Stadium_KC.glb or Stadium_BOS.gltf
  const match = fileName.match(/Stadium_([A-Z]{2,3})\b/i);
  if (match && match[1]) {
    const code = match[1].toUpperCase();
    if (STADIUM_METADATA[code]) {
      return STADIUM_METADATA[code].name;
    }
  }
  
  // Try matching abbreviations without prefix (e.g. KC.glb)
  const shortMatch = fileName.match(/^([A-Z]{2,3})\.(glb|gltf)$/i);
  if (shortMatch && shortMatch[1]) {
    const code = shortMatch[1].toUpperCase();
    if (STADIUM_METADATA[code]) {
      return STADIUM_METADATA[code].name;
    }
  }

  // Fallback: Clean up custom file names (e.g. "my_custom_field.glb" -> "My Custom Field")
  let cleanName = fileName.replace(/\.[^/.]+$/, ""); // Strip file extension
  cleanName = cleanName.replace(/Stadium_/g, "");     // Strip Stadium_ prefix
  cleanName = cleanName.replace(/_/g, " ");          // Replace underscores with spaces
  cleanName = cleanName.replace(/-/g, " ");          // Replace dashes with spaces
  
  return cleanName
    .split(' ')
    .filter(Boolean)
    .map(w => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}

/**
 * Returns stadium metadata mapping containing teamId, name, and tz.
 * @param {string} fileName - Stadium filename (e.g. Stadium_KC.glb)
 * @returns {object|null} Metadata block or null
 */
export function getStadiumMetadata(fileName) {
  if (!fileName) return null;
  
  const match = fileName.match(/Stadium_([A-Z]{2,3})\b/i);
  if (match && match[1]) {
    const code = match[1].toUpperCase();
    if (STADIUM_METADATA[code]) {
      return { code, ...STADIUM_METADATA[code] };
    }
  }
  
  const shortMatch = fileName.match(/^([A-Z]{2,3})\.(glb|gltf)$/i);
  if (shortMatch && shortMatch[1]) {
    const code = shortMatch[1].toUpperCase();
    if (STADIUM_METADATA[code]) {
      return { code, ...STADIUM_METADATA[code] };
    }
  }
  
  return null;
}
